import {TableRow} from "@hosttools/frontend/components";

export default TableRow;
